import React, { Fragment } from 'react'
import Component from 'components/component'
import { DI } from 'modules'

function Login(props) {
  const { common:{strings}, buttonText } = props

  const signIn = ev => {
    ev.preventDefault()
    props.actions.common.openSignInModal()
  }

  return (
    <Fragment>
      <div
        className={Component.classList(
          'live-download',
          !props.withRestrictions && 'live-download--not-padded'
        )}
      >
        <button type="button" className="button" onClick={signIn}>
          {buttonText || strings['page.video.left.download']}
        </button>
      </div>
    </Fragment>
  )
}

export default DI(['common'])(Login)
